module.exports = __webpack_public_path__ + "img/Flag_of_Andorra.248abfff.svg";